import { render, staticRenderFns } from "./AboutOneMenu.vue?vue&type=template&id=d6c4c242"
import script from "./AboutOneMenu.vue?vue&type=script&lang=js"
export * from "./AboutOneMenu.vue?vue&type=script&lang=js"
import style0 from "./AboutOneMenu.vue?vue&type=style&index=0&id=d6c4c242&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports